const zh = {
  "app.webcheckin.title": "线上值机",
  "app.webcheckin.no_booking": "预订编号",
  "app.webcheckin.customer": "客户",
  "app.webcheckin.channel": "预订渠道",
  "app.webcheckin.reservation_detail": "预订详情",
  "app.webcheckin.experiences": "体验项目",
  "app.webcheckin.meal_plan": "餐饮方案",
  "app.webcheckin.nights_quantity": "{nights} 晚",
  "app.webcheckin.reserved rooms": "已预订客房",
  "app.webcheckin.intro_info": "现在您可以快速、轻松地完成入住。",
  "app.webcheckin.view_guest": "查看已登记的住客",
  "app.webcheckin.max_accommodation": "最多可入住 {max} 位住客",
  "app.webcheckin.register_guest": "登记住客",
  "app.webcheckin.hello": "您好，",
  "app.webcheckin.name_guest": "姓名",
  "app.webcheckin.type_guest": "类型",
  "app.webcheckin.melhous_btn": "查看 MELHOUS",
  "staff.supply.no_signature": "未添加签名",
  "app.webcheckin.contact": "联系方式",
  "app.webcheckin.experiences.melhous": "专为客户打造的独家应用",
  "app.webcheckin.arrive.date": "到达",
  "app.webcheckin.departure.date": "离开",
  "app.webcheckin.melhos.description":
    "通过 Melhous，您现在可以独享我们为客户提供的最佳服务和独特体验。了解所有信息。 ",
  "app.webcheckin.melhos.click": "这里。",
  "app.webcheckin.experiences.description": "享受我们为您精心准备的最佳体验。",
  "app.webcheckin.msg_ok": "注册已成功完成。",
  "app.webcheckin.extra_fields": "附加字段",
  "app.webcheckin.placeholder.description": "输入描述",
  "app.webcheckin.main_guest_description": "此登记将属于预订的主要住客。",
};

export default zh;
